export const fluentLanguageId = 'fluent'
